<div class="l-top-navi">
  <div class="l-wrap l-wrap--sp-tb-full">
    <div class="l-wrap__inner">
      <div class="l-top-navi__inner l-top-navi__inner--has-progress">
        <div class="l-top-navi__back-area" *ngIf="this.isDisplayBackButton">
          <a
            id="reservation-basic-information-input-sub-header-back"
            class="l-top-navi__back-link"
            [routerLink]="this.SERVICING_ROUTES.myBooking"
            ><span class="u-visually-hidden" innerHTML="{{ 'reader.goBackToPreviousPage' | staticMsg }}"></span
          ></a>
        </div>
        <div
          [ngClass]="
            this.isDisplayBackButton ? 'l-top-navi__heading-area' : 'l-top-navi__heading-area　clear-left-space'
          "
        >
          <h1 class="l-top-navi__heading-text" innerHTML="{{ 'heading.basicReservationInformation' | staticMsg }}"></h1>
        </div>
      </div>
    </div>
  </div>
</div>
